import { useState, useEffect } from 'react';

interface CountdownData {
  title: string;
  targetDate: Date;
  icon: string;
  color: string;
}

export default function CountdownTimers() {
  const countdowns: CountdownData[] = [
    {
      title: '國三會考倒數',
      targetDate: new Date('2026-05-17'),
      icon: 'ri-trophy-line',
      color: 'from-red-500 to-orange-500'
    },
    {
      title: '國中月考倒數',
      targetDate: new Date('2025-12-03'),
      icon: 'ri-file-text-line',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      title: '國小月考倒數',
      targetDate: new Date('2026-01-13'),
      icon: 'ri-book-open-line',
      color: 'from-green-500 to-teal-500'
    },
    {
      title: '寒令營倒數',
      targetDate: new Date('2026-01-26'),
      icon: 'ri-calendar-event-line',
      color: 'from-purple-500 to-pink-500'
    }
  ];

  const [timeLeft, setTimeLeft] = useState<{ [key: string]: { days: number; hours: number; minutes: number; seconds: number } }>({});

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const newTimeLeft: { [key: string]: { days: number; hours: number; minutes: number; seconds: number } } = {};

      countdowns.forEach((countdown) => {
        const difference = countdown.targetDate.getTime() - now;

        if (difference > 0) {
          newTimeLeft[countdown.title] = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
            seconds: Math.floor((difference % (1000 * 60)) / 1000)
          };
        } else {
          newTimeLeft[countdown.title] = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
          };
        }
      });

      setTimeLeft(newTimeLeft);
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 py-6">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {countdowns.map((countdown, index) => {
            const time = timeLeft[countdown.title] || { days: 0, hours: 0, minutes: 0, seconds: 0 };
            
            return (
              <div
                key={index}
                className={`bg-gradient-to-br ${countdown.color} rounded-xl p-5 shadow-lg transform hover:scale-105 transition-transform`}
              >
                <div className="flex items-center justify-center mb-3">
                  <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mr-2">
                    <i className={`${countdown.icon} text-white text-xl`}></i>
                  </div>
                  <h3 className="text-white font-bold text-lg">{countdown.title}</h3>
                </div>

                <div className="grid grid-cols-4 gap-2">
                  <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2 text-center">
                    <div className="text-2xl font-bold text-white">{time.days}</div>
                    <div className="text-xs text-white/80">天</div>
                  </div>
                  <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2 text-center">
                    <div className="text-2xl font-bold text-white">{time.hours}</div>
                    <div className="text-xs text-white/80">時</div>
                  </div>
                  <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2 text-center">
                    <div className="text-2xl font-bold text-white">{time.minutes}</div>
                    <div className="text-xs text-white/80">分</div>
                  </div>
                  <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2 text-center">
                    <div className="text-2xl font-bold text-white">{time.seconds}</div>
                    <div className="text-xs text-white/80">秒</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
